<template>
    <rkm-table
        :items="data.model.lotacoesExameLaboratorial"
        :fields="fields.datatables.lotacao"
    >
        <template v-slot:cell(actions)="{ index }">
            <rkm-button
                @click="handleDestroy(index)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    computed: {
        fields() {

            return {
                datatables: {
                    lotacao: [
                        { key: 'usuarioNome', label: 'Profissional', sortable: true },
                        { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true },
                        { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                        { key: 'ocupacaoDescricao', label: 'CBO', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        }
    },
    methods: {
        handleDestroy(index) {

            const destroy = async () => this.data.model.lotacoesExameLaboratorial.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o profissional?', destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>